import { useState, useEffect } from 'react';

/**
 * 現在時刻を定期的に更新するフック。
 * 戻り値は生のDate（タイムスタンプは正確だが、年月日時分の読み出しにはTZ注意）。
 *
 * YOU MUST: 戻り値から年月日や時分を取り出すときは、`.getHours()` 等を直接呼ばず
 * `frontend/src/utils/businessDate.ts` の `getJstDateInfo(now)` を経由すること。
 * 直接呼ぶとブラウザのローカルTZ値が返り、JST前提のロジックとズレる。
 *
 * @param intervalMs 更新間隔（ミリ秒）デフォルト30秒
 */
export const useCurrentTime = (intervalMs = 30000) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setNow(new Date());
    }, intervalMs);

    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
};
